import script from "./MallCartPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallCartPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallCartPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__